import { FC } from 'react'
import { environment, ErrorViewer } from 'react-common'

const isDev = environment().environment === 'dev'

export const ErrorFallback: FC<{ error: Error }> = ({ error }) => {
  return <ErrorViewer code={500} text={isDev ? error?.stack : 'Something went wrong'} fullScreen />
}
